
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.97 21.645c-.042.152.059.31.217.322a9.956 9.956 0 006.926-2.052.245.245 0 00.02-.367l-5.956-5.957a.25.25 0 00-.354 0l-1.841 1.841a.257.257 0 00-.026.33 7.007 7.007 0 011.014 5.883zM8.685 21.437a.236.236 0 00.305-.15 5.012 5.012 0 00-.435-4.006.239.239 0 00-.378-.044l-2.31 2.31a.245.245 0 00.02.368 9.978 9.978 0 002.798 1.522zM4.085 18.113c.09.117.263.125.367.02l2.311-2.31a.239.239 0 00-.044-.378 5.012 5.012 0 00-4.006-.435.236.236 0 00-.15.306 9.98 9.98 0 001.522 2.797zM2.033 12.813c.012.158.17.26.322.217a7.007 7.007 0 015.884 1.014c.102.072.24.062.329-.026l1.841-1.841a.25.25 0 000-.354L4.452 5.867a.245.245 0 00-.367.02 9.957 9.957 0 00-2.052 6.926zM5.867 4.452a.245.245 0 01.02-.367A9.952 9.952 0 0112 2c.274 0 .545.011.813.033.158.012.26.17.217.322a7.007 7.007 0 001.014 5.884.257.257 0 01-.026.329l-1.841 1.841a.25.25 0 01-.354 0L5.867 4.452zM15.315 2.563a.236.236 0 00-.305.15 5.012 5.012 0 00.435 4.007.239.239 0 00.377.043l2.312-2.31a.245.245 0 00-.021-.368 9.98 9.98 0 00-2.798-1.522zM19.915 5.887a.245.245 0 00-.367-.02l-2.311 2.31a.239.239 0 00.044.378 5.012 5.012 0 004.006.435.236.236 0 00.15-.305 9.978 9.978 0 00-1.522-2.798zM21.967 11.187a.253.253 0 00-.322-.217 7.008 7.008 0 01-5.884-1.014.256.256 0 00-.329.026l-1.841 1.841a.25.25 0 000 .354l5.957 5.957a.245.245 0 00.367-.021 9.957 9.957 0 002.052-6.926z"}})])
          )
        }
      }
    